import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ProblemListPage } from '@/features/AdminProblems/ProblemListPage';

export const Route = createFileRoute('/admin/problems/')({
  component: AdminProblemsPage,
});

function AdminProblemsPage() {
  const navigate = useNavigate();
  return (
    <ProblemListPage
      onOpenProblem={id => navigate({ to: '/admin/problems/$problemId', params: { problemId: id } })}
      onNewProblem={() => navigate({ to: '/admin/problems/new' })}
    />
  );
}
